import { render, staticRenderFns } from "./CourseTypeDropdown.vue?vue&type=template&id=a586200a&"
import script from "./CourseTypeDropdown.vue?vue&type=script&lang=ts&"
export * from "./CourseTypeDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports